import types from '../types'
import api from '@/pages/comet/api'
const profile = {
  avatar: '',
  user_id: '',
  username: '',
  email: '',
  nickname: '',
  role: 0,
  gender: '',
  birthday: '',
  school: '',
  grade: '',
  target_university: '',
  signature: '',
  proton: 0,
  neutron: 0
}
const state = {
  profile: profile
}

const getters = {
  profile: state => state.profile || {},
  isAuthenticated: (state, getters) => {
    return !!getters.profile.user_id
  },
  isAdminRole: (state, getters) => {
    return getters.profile.role === 1
  }
}

const mutations = {
  [types.CHANGE_PROFILE] (state, { profile }) {
    state.profile = profile
  }
}

const actions = {
  getProfile ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getUserInfo().then(res => {
        commit(types.CHANGE_PROFILE, {
          profile: res.data.data || profile
        })
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  updateUserInfo ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.updateUserInfo(payload).then(res => {
        commit(types.CHANGE_PROFILE, {
          profile: res.data.data || profile
        })
        this.dispatch('getProfile')
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  clearProfile ({ commit }) {
    commit(types.CHANGE_PROFILE, {
      profile: profile
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
